// BUSINESS LINES
import {
  CREATE_BUSINESS_LINE,
  CREATE_BUSINESS_LINE_SUCCESS,
  CREATE_BUSINESS_LINE_ERROR,
  DELETE_BUSINESS_LINE,
  DELETE_BUSINESS_LINE_SUCCESS,
  DELETE_BUSINESS_LINE_ERROR,
  HIDE_DELETE_BUSINESS_LINE_ERROR,
} from '../constants/action-types/businessLines';

export const createBusinessLine = (clientId, name, state = '') => ({
  type: CREATE_BUSINESS_LINE,
  payload: {
    clientId,
    name,
    state,
  },
});

export const createBusinessLineSuccess = businessLine => ({
  type: CREATE_BUSINESS_LINE_SUCCESS,
  payload: {
    businessLine,
  },
});

export const createBusinessLineError = error => ({
  type: CREATE_BUSINESS_LINE_ERROR,
  payload: {
    error,
  },
});

export const deleteBusinessLine = id => ({
  type: DELETE_BUSINESS_LINE,
  payload: {
    id,
  },
});

export const hideDeleteBusinessLineError = () => ({
  type: HIDE_DELETE_BUSINESS_LINE_ERROR,
  payload: {},
});

export const deleteBusinessLineSuccess = () => ({
  type: DELETE_BUSINESS_LINE_SUCCESS,
});

export const deleteBusinessLineError = error => ({
  type: DELETE_BUSINESS_LINE_ERROR,
  payload: {
    error,
  },
});
